import Decimal from 'decimal.js-light';
import { IComputeMathFunction } from './IComputeMathFunction';

export const ComputeMathListFunctions: IComputeMathFunction[] = [
  /**
   * Ottiene il numero di elementi di un array
   */
  {
    name: 'numero_elementi',
    description: 'Restituisce il numero di elementi di una lista',
    arguments: [{ type: 'list' }],
    returnType: 'number',
    signature: 'numero_elementi(lista: Lista): Numero',
    fn: MathJs =>
      MathJs.typed('numero_elementi', {
        [`Array`]: function (a: unknown[]) {
          return a == null ? 0 : a.length;
        },
      }),
  },
  /**
   * Ottiene la somma degli elementi di un array
   */
  {
    name: 'somma_elementi',
    description: 'Restituisce la somma degli elementi di una lista',
    arguments: [{ type: 'list' }, { type: 'string' }],
    returnType: 'number',
    signature: 'somma_elementi(lista: Lista, campo: Stringa): Numero',
    fn: MathJs => {
      return MathJs.typed('somma_elementi', {
        [`Array, string`]: function (
          a: Array<Record<string, any>>,
          field: string,
        ) {
          if (a == null) return 0;
          return a
            .reduce((acc: Decimal, curr) => {
              if (curr[field] == null) {
                return acc;
              }
              // Utilizziamo Decimal per evitare problemi di arrotondamento
              // e per poter gestire anche le currency
              try {
                // Se curr[field] non è un Decimal|number|string e non può essere convertito in un numero
                // allora viene ignorato (il constructor lancia un'eccezione)
                const value = new Decimal(curr[field]);
                return acc.add(value);
              } catch (e) {
                return acc;
              }
            }, new Decimal(0))
            .toNumber();
        },
      });
    },
  },
];
